import { useEffect } from "react";
import { P, match } from "ts-pattern";
import { ApplicationKey } from "../utils/applications";

const defaultTitle = document.title;

export const useTitle = (title: string, fromApp?: ApplicationKey) => {
  useEffect(() => {
    const suffix = match(fromApp)
      .with("dedale", () => "Dedale by Bireme Lab")
      .with(P.nullish, () => undefined)
      .exhaustive();

    document.title = `${title} | ${suffix ?? defaultTitle}`;

    return () => {
      document.title = defaultTitle;
    };
  }, [title, fromApp]);
};
